import { Component, ErrorInfo, ReactNode } from "react";
import i18n from "../i18n/config";
import { logger } from "../utils/logger";

interface State {
    hasError: boolean;
}

/**
 * Catches render errors anywhere below it (GOD-59): instead of a white page
 * the user gets a short note with "reload" and "start page", and the error is
 * reported through the logger.
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        logger.error("ErrorBoundary", error, { fatal: true });
        logger.warn("ErrorBoundary.componentStack", info.componentStack);
    }

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div className="container py-5" style={{ maxWidth: 560 }} role="alert" data-testid="error-boundary">
                <h1 className="h3 mb-3">{i18n.t("errorPage.title")}</h1>
                <p className="text-muted">{i18n.t("errorPage.text")}</p>
                <div className="d-flex gap-2">
                    <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
                        {i18n.t("errorPage.reload")}
                    </button>
                    <a className="btn btn-outline-secondary" href="/">
                        {i18n.t("errorPage.home")}
                    </a>
                </div>
            </div>
        );
    }
}
